module.exports = __webpack_public_path__ + "img/positive_refaming_trigger.944f2ab0.jpg";